export default __webpack_public_path__ + "static/media/logo.285981e1.png";